/* eslint-disable @typescript-eslint/no-unused-vars */

import SimulatePurchases from "./lib/SimulatePurchases";

const RebateOfferTools = () => {
	return (
		<div>
			<>
				<SimulatePurchases />
			</>
		</div>
	);
};

export default RebateOfferTools;
